import React, { useState } from 'react';
import LastMenu from "../ChatFlow/Lastmenu";
const CenterofExcellence = () => {
  const handleShowFrame = (id, speciality) => {
    console.log(`Selected ID: ${id}, Speciality: ${speciality}`);
    // You can add any functionality here when a button is clicked
  };

  return (
    <>
    <div>
      <a href="https://www.medicoverhospitals.in/specialties/cardiology" target="_blank" rel="noopener noreferrer">
        <button className='menu-btn' onClick={() => handleShowFrame(1, "Cardiology")}>Cardiaology</button>
      </a>
      <a href="https://www.medicoverhospitals.in/specialties/gastroenterology" target="_blank" rel="noopener noreferrer">
        <button className='menu-btn' onClick={() => handleShowFrame(2, "Surgical Gastroenterology")}>Gastroenterology</button>
      </a>
      <a href="https://www.medicoverhospitals.in/specialties/oncology" target="_blank" rel="noopener noreferrer">
        <button className='menu-btn' onClick={() => handleShowFrame(3, "Neuro-Surgery")}>Oncology</button>
      </a>
      <a href="https://www.medicoverhospitals.in/specialties/general-surgery" target="_blank" rel="noopener noreferrer">
        <button className='menu-btn' onClick={() => handleShowFrame(4, "Orthopedics")}>General Surgery</button>
      </a>
      <a href="https://www.medicoverhospitals.in/specialties/orthopedics" target="_blank" rel="noopener noreferrer">
        <button className='menu-btn' onClick={() => handleShowFrame(5, "Nephrology")}>Orthopedics</button>
      </a>
    </div>
     <LastMenu/>
     </>
  );
};

export default CenterofExcellence;
